import withInfiniteOptions from "@/components_v2/FormFields/Dropdown/hocs/withInfiniteOptions";
import BaseDropdown from "@/components_v2/FormFields/Dropdown/BaseDropdown";

const InfiniteScrollDropdown = withInfiniteOptions(BaseDropdown);

export default InfiniteScrollDropdown;
